import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from "react-router-dom";
import { LangProviderWrapper } from './context/language.context';
import { AppContextProvider } from './context/app.context.js';
import { OpenContextProvider } from './context/open.context.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
    <OpenContextProvider>
      <AppContextProvider>
      <LangProviderWrapper>
    <App />
    </LangProviderWrapper>
    </AppContextProvider>
    </OpenContextProvider>
    </Router>
  </React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
